export default {
    meta: {
        label: 'Italiano'
    },
    data: {
        'it': {
            97: [['🦆', 'anatra'], ['⚓️', 'ancora'], ['🍍', 'ananas'], ['🚑', 'ambulanza'], ['🐝', 'ape'], ['🥜', 'arachide'], ['🚗', 'automobile'], ['🍉', 'anguria']],
            98: [['🍌', 'banana'], ['👶', 'bambino'], ['🥦', 'broccoli'], ['🥖', 'baguette'], ['🥓', 'bacon'], ['🚲', 'bicicletta']],
            99: [['🦐', 'casco'], ['🥕', 'carota'], ['🐗', 'cinghiale'], ['⛪', 'chiesa'], ['🍩', 'ciambella'], ['🍫', 'cioccolata'], ['🐊', 'coccodrillo'], ['☕', 'caffè'], ['🥄', 'cucchiaio'], ['🏠', 'casa']],
            100: [['🦕', 'dinosauro'], ['🎲', 'dado'], ['💵', 'denaro'], ['🐉', 'drago']],
            101: [['🐘', 'elefante'], ['🚁', 'elicottero']],
            102: [['👻', 'fantasma'], ['🧀', 'formaggio'], ['🍓', 'fragola'], ['🍄', 'fungo'], ['🐜', 'formica'], ['🦋', 'farfalla']],
            103: [['🦒', 'giraffa'], ['📰', 'giornale'], ['🦍', 'gorila'], ['🐱', 'gatto'], ['🐔', 'gallina'], ['🦉', 'gufo'], ['🍦', 'gelato']],
            104: [['🏨', 'hotel']],
            105: [['🏝️', 'isola']],
            106: [],
            107: [['🥝', 'kiwi']],
            108: [['🦁', 'leone']],
            109: [['🐮', 'mucca'], ['🐷', 'maiale'], ['🍎', 'mela']],
            110: [['👃', 'narici'], ['🌃', 'notte'], ['☁', 'nuvola']],
            111: [['👂', 'orecchio'], ['👁', 'occhio']],
            112: [['🐼', 'panda'], ['🦇', 'pipistrello'], ['🐑', 'pecora'], ['🥔', 'patata'], ['🐧', 'pinguino'], ['🐟', 'pesce'], ['🤡', 'pagliaccio']],
            113: [['🖼', 'quadro']],
            114: [['🤖', 'robot'], ['🐭', 'ratto']],
            115: [['🐵', 'scimmia'], ['🐿', 'scoiattolo'], ['🧜', 'sirena'], ['🍣', 'sushi'], ['🐍', 'serpente']],
            116: [['🐆', 'tigre'], ['🐺', 'topo'], ['🐢', 'tartaruga'], ['🌮', 'tacos']],
            117: [['🦄', 'unicorno'], ['🍇', 'uva']],
            118: [['🧛‍♂️', 'vampiro'], ['🌋', 'vulcano']],
            119: [],
            121: [['☯️', 'yin yang']],
            122: [['🦓', 'zebra'], ['🧟', 'zombi'], ['🦊', 'zorro']]
        }
    }
};
